import { Vue } from 'vue-property-decorator';

import {
   formatterDate,
   formatterTime,
   formatterFloat,
   formatterNumber,
   formatterInt,
   formatDate,
   formatTime,
   parseFloatCustom,
   parseIntCustom,
   formatStringTime,
   customFormatter,
} from '@/config/functions';

import { find, mapValues } from 'lodash';

const currencies = mapValues(require('currency-formatter/currencies.json'), (c: any) => ({
   ...c,
   symbolPosition: c.symbolOnLeft ? 'front' : '',
   fractionCount: c.decimalDigits,
}));

export default class BasePage extends Vue {
   customFormatter: any = customFormatter;

   formatterFloat = formatterFloat;

   formatterNumber = formatterNumber;

   formatterInt = formatterInt;

   formatterTime = formatterTime;

   formatterDate = formatterDate;

   formatDate = formatDate;

   formatTime = formatTime;

   parseFloatCustom = parseFloatCustom;

   parseIntCustom = parseIntCustom;

   formatStringTime: any = formatStringTime;

   currencies!: any[];

   currencyParams: any = currencies['EUR'];

   getDictionary(dictionary: any[] | string) {
      if (typeof dictionary == 'string') {
         dictionary = (Array.isArray(this.$store.state.activities[dictionary]) ? this.$store.state.activities[dictionary] : []) as any[];
      }

      return dictionary;
   }

   dataFromDictionary(dictionary: any[] | string, id: number | string | null) {
      dictionary = this.getDictionary(dictionary);

      return id
         ? find(
              dictionary,
              d =>
                 d?.id == id ||
                 d?.d_id == id ||
                 d?.d_code == id ||
                 d?.value == id ||
                 d?.bps_id == id ||
                 d?.bps_code == id ||
                 d?.iso639_id == id ||
                 d?.iso639_a2 == id ||
                 d?.iso3166_id == id ||
                 d?.iso3166_a2 == id ||
                 d?.iso4217_id == id ||
                 d?.iso4217_a2 == id ||
                 d?.iso4217_a3 == id
           )
         : false;
   }

   valueFromDictionary(dictionary: any[] | string, id: number | string, key?: string, def?: any) {
      const d = this.dataFromDictionary(dictionary, id);
      if (!d) return def ?? null;
      return key ? (typeof d[key] != 'undefined' ? d[key] : '') : this.$options.filters?.getI18nName(d);
   }

   showMessage(innerHTML: string, params: any = {}) {
      const h = this.$createElement;

      const description = h('div', {
         class: ['modal-scrollable'],
         domProps: { innerHTML },
      });

      return this.$bvModal.msgBoxOk([description], {
         'ok-title': this.$t('buttons.ok'),
         ...params,
      });
   }
}
